import styled from "styled-components";
import { Collapse, Form, Row } from "antd";


export const ModalTitle = styled.span`
    font-size: 20px;
    line-height: 32px;
    font-weight: 700;
    color: #212529;
`


export const ModalBodyItem = styled(Form.Item)`
    width:100%;
`
export const ModalBodyItemLeft = styled(Form.Item)`
    width: 100%;
    margin-right: 16px;
`

export const ModalBodyItemText = styled.span`
    font-size: 12px;
    line-height: 24px;
    font-weight: 400;
    color: #212529;
`

export const ModalBodyInline = styled.div`
    display:flex;
`